import React from 'react';
import _ from 'underscore';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acBilet } from '../actions/acBilet'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'

class NrFavoriteMiddle extends React.Component {

    constructor() {
        super();
        this.state = {
            star: false,
            checked: false
        };
    }
    componentDidMount() {
        if (this.props.bilete && this.props.bilete.length > 0) {
            // var findBiletThis = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            if (this.props.nrFavoriteMiddle !== null) {
                var values = {
                    position: this.props.biletTab,
                    nrFavorite: this.props.nrFavoriteMiddle.value
                }
                this.props.acBilet(['biletSaveFav', values])
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // ticket with same poz and diff lot_name
        var findBiletThis = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        var findBiletPrev = _.findWhere(prevProps.bilete, { position: this.props.biletTab });
        if ((findBiletThis) && (findBiletPrev)) {
            if (findBiletThis.numeLot !== findBiletPrev.numeLot) {
                var nrFav = {
                    ruta: this.props.appProps.ruta,
                    reducer: 'NR_FAVORITE_MIDDLE',
                    request: 'get_user_favorites',
                    value: 'lottery_name=' + findBiletThis.numeLot.replace(/ /g, "_"),
                    error: '5100',
                    reducer2: 'BILET_SAVE_FAV_FROM_AXIOS',
                    extra: this.props.biletTab,
                    newParam: this.props.sessionParam
                }
                this.props.acAxiosRequest(nrFav);
            }
        }

    }
    _onSelect(e) {
        var nrFavorite = [], rundaVal = this.props.rundaSelectata

        for (var i = 0; i < e.value.split(',').length; i++) {
            nrFavorite.push(parseInt(e.value.split(',')[i], 10))
        }
        var valBiletNou = {
            idRunda: rundaVal.id,
            roundUnique: rundaVal.round_unique,
            numereArr: nrFavorite,
            timeStart: rundaVal.timeStart,
            numeLot: rundaVal.selectedLot,
            gameType: this.props.activeLot.game_type,
            odds: this.props.activeLot.odds,
            miza: 0,
            currency: this.props.defaultVal.currency,
            checked: [1],
            cotaTot: 0,
            castigEv: 0,
            sum: [],
            coteFixe: [],
            position: this.props.biletTab,
            valid: true,
            pariat: false,
            mesaj: '',
            future: 0,
            futureSuccess: 0,
            futureError: 0,
            futureErrorRounds: [],
            futureMessage: [this.props.multiLang.biletePariate.txt, this.props.multiLang.bileteEsuate.txt],
            nrFavorite: null
        }

        if (e.value !== this.props.multiLang.nofavNb.txt) {
            var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            this.setState({ star: true })
            if (findBilet) {
                var values = {
                    position: findBilet.position,
                    favNumber: e.value,
                    odds: this.props.activeLot.odds
                }
                this.props.acBilet(['biletFavNumere', values])
            } else {
                this.props.acBilet(['biletNou', valBiletNou])
            }
        }
    }
    optionssDD() {
        var arr = [], reverse

        if (Array.isArray(this.props.nrFavoriteMiddle.value)) {
            reverse = this.props.nrFavoriteMiddle.value.reverse()
            for (let i = 0; i < reverse.length; i++) {
                arr.push(reverse[i].replace(/,/g, ", "))
            }
        }
        else {
            arr = [this.props.multiLang.nofavNb.txt]
        }
        return arr

    }
    activeSelect(e) {
        return 'active'
    }
    starClass() {
        if (this.state.star === true) {
            return 'change'
        }
        else {
            return ''
        }
    }
    render() {
        var favoritePlaceholder = this.props.multiLang.selectFavNb.txt
        if (this.props.conSizeChange.appW <= 700) {
            favoritePlaceholder = this.props.multiLang.fav.txt
        }
        return (
            <div className="con-nr-fav">
                <div className="fav">
                    <span>{this.props.multiLang.fav.txt}</span>
                    <span className={"star " + this.starClass()}></span>
                    <Dropdown className={this.activeSelect()} options={this.optionssDD()} onChange={this._onSelect.bind(this)} placeholder={favoritePlaceholder} />
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        biletTab: state.biletTab,
        bilete: state.bilete,
        appProps: state.appProps,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        nrFavoriteMiddle: state.nrFavoriteMiddle,
        multiLang: state.multiLang,
        rundaSelectata: state.rundaSelectata,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acBilet: acBilet,
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(NrFavoriteMiddle);